// Import and expose jQuery globally
import $ from 'jquery';
window.$ = window.jQuery = $;

// Import Slick Carousel
import 'slick-carousel';


$(document).ready(function () {


   $('.sliderteaser > .teasers').on('afterChange', function(event, slick, currentSlide){
         lazyLoadInstance.update();
    });

   $('.sliderteaser > .teasers').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });

   $('.sliderthis').on('init', function(event, slick){
console.log("here");

         lazyLoadInstance.update();
    });

   $('.teasers.layout-unternehmensgeschichte').on('init', function(event, slick){
    lazyLoadInstance.update();
    $('.teasers.layout-unternehmensgeschichte').css('visibility','visible');
      var maxheight = $('.unternehmensgeschichte-section .slick-track').outerHeight();
      $('.unternehmensgeschichte-section .slick-track').css('height',maxheight+'px');

    });

   
  $('.sliderteaser > .teasers').slick({
         centerMode: true,
          centerPadding: '12%',
          slidesToShow: 3,
          arrows: false,
          focusOnSelect: true,
          slidesToScroll: 1,
          autoplay: false,
          // autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
      });


const $slider = $('.teasers.layout-unternehmensgeschichte');
const totalSlides = $slider.children().length;
const middleSlide = Math.floor(totalSlides / 2);
  $('.teasers.layout-unternehmensgeschichte').slick({
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '12%',
          arrows: true,
          focusOnSelect: true,
          dots: true,
          initialSlide: middleSlide,
          infinite: true,
          slidesToScroll: 1,
          prevArrow: '<button class="slick-prev" aria-label="Previous"> </button>',
          nextArrow: '<button class="slick-next" aria-label="Next"> </button>',
          // autoplay: true,
          // autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                  }
                },
            ]
      });

    $('.sliderthis').slick({
          slidesToShow: 5,
          centerMode: true,
          centerPadding: '0px',
          speed: 1000,
          arrows: false,
          dots: true,
          infinite: true,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 3,
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 2,
                  }
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 1,
                  }
                }
            ]
    });

});